import { useApp } from "../context";

export default function ResetConfirm() {
  const { actions, closeModal } = useApp();
  return (
    <>
      <h2>Reset the demonstration?</h2>
      <p>
        This removes cases, receipts, approvals and notes added in this browser,
        then restores the fictional starting data.
      </p>
      <div className="footer">
        <button data-testid="reset-cancel-btn" onClick={closeModal}>Cancel</button>
        <button className="danger" data-testid="reset-confirm-btn" onClick={actions.resetDemo}>Reset demo</button>
      </div>
    </>
  );
}
